import {Backdrop, CircularProgress, Typography} from '@mui/material';
import 'pages/reports/Info Bar/ReportsInfoBar.css';
import {ReactComponent as SaveButton} from 'assets/SaveButton.svg';
import React, {useState} from 'react';
import {downloadPDF} from 'lib/callBackend';
import {capitalizeFirstLetter, isEmpty} from 'lib/utils/stringUtils';
import T from 'i18n-react';
import {DownloadFailedModalComponent} from "components/DownloadFailedModalComponent";
import {prepareClaimData} from "lib/utils/reportUtils";

const ReportsInfoBar = (props) => {

    const queriedData = props.queriedData;

    const model = queriedData.carModel?.toString() || '';
    const manufacturer = queriedData.carManufacturer?.toString() || '';
    const firstRegistrationDate = queriedData.firstRegistrationDate || '';
    const engineDisplacement = queriedData.engineCC || '';
    const vin = queriedData.vin || '';
    const isDownloadButtonVisible = props.withDownloadButton || false;

    const [downloadButtonLoader, setDownloadButtonLoader] = useState(false);
    const [isDocumentUnavailableModalOpen, setIsDocumentUnavailableModalOpen] = useState(false);

    return (
        <div className={'reportsInfoBar'}>
            <div className={'leftInfoBar'}>
                {isEmpty(manufacturer) ? null :
                    <Typography className={'manufacturerModelTypography'}>
                        {capitalizeFirstLetter(manufacturer)}{isEmpty(model) ? '' : ' / ' + capitalizeFirstLetter(model)}
                    </Typography>}
            </div>
            <div className={'rightInfoBar'}>
                <Typography
                    className={'infoBarYear'}>{T.translate('carDataComponent.registrationYear') + ': ' + (firstRegistrationDate || '-')}</Typography>
                <Typography
                    className={'infoBarEngineDisplacement'}>{T.translate('carDataComponent.engineCC') + ': '}{engineDisplacement ? engineDisplacement + ' cm³' : '-'}</Typography>
                {isDownloadButtonVisible ?
                    <div className={`downloadButton${downloadButtonLoader ? ' loading' : ''}`} onClick={() => {
                        downloadPDF(prepareClaimData({
                            vin: vin,
                            reportData: queriedData,
                            setDownloadButtonLoader: setDownloadButtonLoader
                        })).then(response => {
                            if (!response) {
                                setIsDocumentUnavailableModalOpen(true);
                            }
                        });
                    }
                    }>
                        <SaveButton></SaveButton>
                        <Typography className="downloadButtonText">{T.translate('svgButtons.download')}</Typography>
                    </div>
                    : null}
            </div>
            <DownloadFailedModalComponent isDocumentUnavailableModalOpen={isDocumentUnavailableModalOpen}
                                          setIsDocumentUnavailableModalOpen={setIsDocumentUnavailableModalOpen}/>
            {downloadButtonLoader ? <Backdrop sx={{zIndex: 50000}} open={downloadButtonLoader}>
                <CircularProgress color={'primary'} size={150}/>
            </Backdrop> : null}
        </div>
    );

};

export default ReportsInfoBar;
